<template>
    <article>
        <h1>Develteam</h1>
        <h3>2012 - Present</h3>

        <section>
            <div class="links">
                <p><a href="https://www.develteam.com" target="_blank">Visit Develteam</a></p>
            </div>

            <div class="two-columns">
                <div>
                    <img src="../assets/page-develteam/screenshot.png" alt="Develteam.com">
                </div>

                <div>
                    <p>
                        Develteam is a social network for Game Developers, focused on showcasing their portfolios and
                        finding other developers to collaborate on projects with. Features on the site include portfolio
                        profiles, group profiles, mixed-media feed posts, forums, global chat, group chat, private chat,
                        inbox messaging, developer and game searching, classifieds, and a community driven catalog of
                        tools and assets. There are over 6000 registered developers and over 800 game projects.
                    </p>
                </div>
            </div>
        </section>


        <h2>About the Development of Develteam</h2>
        <h3>VueJS, LESS, NodeJS, Express, MySQL, WebPack</h3>

        <section>
            <div class="links">
                <p><a href="https://github.com/Garmichael/Develteam" target="_blank">Develteam Source Code on Github</a></p>
            </div>


            <div class="one-column">
                <p>
                    Develteam is a reactive Single Page Web Application and uses NodeJS with Express for the server,
                    MySQL for the database, and VueJS / Vuex / LESS for the front end. The entire stack is built from
                    scratch. I developed and maintain the site solo, with input from the community.
                </p>

                <p>
                    There are over 80 API endpoints, 100+ pages and widgets as .vue files most of which have dedicated
                    .less and vuex stores, and dozens of database tables. The site is built modularly so that assets and
                    templates can be reused.
                </p>

                <p>
                    Initial Development took about six months, with bug fixes, new features, and optimizations being
                    done since as needed.
                </p>
            </div>
        </section>

        <p></p>
    </article>
</template>

<script>
    export default {
        name: "Develteam"
    }
</script>